import config from '../../config';

export default {
  url: `${config.api.baseURL}/onboarding/content`,
  transformer(data) {
    return data;
  }
};
